/* OptiBio Capsule Reveal — scroll-driven capsule opening.
   Reads its settings from data-* attributes on the section root so one script
   serves any number of instances. Theme-editor safe. */
(function () {
  'use strict';

  var ART_W = 458;
  var ART_H = 1401;
  var CAP_SLIDE = 300;      // px of art space the cap travels to seat on the cup
  var CARD_COUNT = 4;

  function cl(n) { return Math.max(0, Math.min(1, n)); }
  function out(n) { return 1 - Math.pow(1 - n, 3); }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }

  function Reveal(root) {
    this.root = root;
    this.q = function (sel) { return root.querySelector(sel); };
    this.el = {
      track: this.q('[data-ocr="track"]'),
      sticky: this.q('[data-ocr="sticky"]'),
      scene: this.q('[data-ocr="scene"]'),
      stage: this.q('[data-ocr="stage"]'),
      head: this.q('[data-ocr="head"]'),
      capsule: this.q('[data-ocr="capsule"]'),
      bob: this.q('[data-ocr="bob"]'),
      cap: this.q('[data-ocr="cap"]'),
      cup: this.q('[data-ocr="cup"]'),
      burst: this.q('[data-ocr="burst"]'),
      glow: this.q('[data-ocr="glow"]'),
      hint: this.q('[data-ocr="hint"]'),
      after: this.q('[data-ocr="after"]')
    };
    if (!this.el.track || !this.el.scene || !this.el.stage) return;

    var d = root.dataset;
    this.conf = {
      vh: num(d.ocrPace, 260),
      cards: d.ocrCards !== 'false',
      vol: num(d.ocrPowder, 100) / 100,
      float: d.ocrFloat !== 'false',
      lift: num(d.ocrOpen, 100) / 100
    };

    this.lastP = -1;
    this.t0 = (window.performance && performance.now()) ? performance.now() : Date.now();
    this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.mount();
  }

  Reveal.prototype.now = function () {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  };

  Reveal.prototype.mount = function () {
    var self = this;
    this.collect();
    this.layout();

    this.onScroll = function () { self.sync(); };
    document.addEventListener('scroll', this.onScroll, { passive: true, capture: true });
    this.onResize = function () { self.layout(); self.lastP = -1; self.sync(); };
    window.addEventListener('resize', this.onResize, { passive: true });

    this.visible = true;
    if (window.IntersectionObserver) {
      this.io = new IntersectionObserver(function (es) {
        self.visible = es.some(function (e) { return e.isIntersecting; });
      }, { rootMargin: '25%' });
      this.io.observe(this.el.track);
    }

    this.tick = function () {
      self.sync();
      if (self.el.bob) {
        var drift = (self.visible && self.conf.float && !self.reduced)
          ? Math.sin((self.now() - self.t0) / 1000 * 0.62) * 8 : 0;
        // yComp re-centres the group while shut, so the closed frame is not bottom-heavy
        self.el.bob.style.transform = 'translate3d(0,' + (drift + (self.yComp || 0)).toFixed(2) + 'px,0)';
      }
      self.raf = requestAnimationFrame(self.tick);
    };
    this.raf = requestAnimationFrame(this.tick);
    this.poll = setInterval(function () { self.sync(); }, 120);
    requestAnimationFrame(function () { self.layout(); self.lastP = -1; self.sync(); });
  };

  Reveal.prototype.destroy = function () {
    document.removeEventListener('scroll', this.onScroll, { capture: true });
    window.removeEventListener('resize', this.onResize);
    if (this.io) this.io.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.poll) clearInterval(this.poll);
  };

  Reveal.prototype.collect = function () {
    var root = this.root, i;
    this.cards = [];
    for (i = 0; i < CARD_COUNT; i++) this.cards.push(root.querySelector('[data-ocr-card="' + i + '"]'));
    this.sides = Array.prototype.slice.call(root.querySelectorAll('[data-ocr-side]'));
    this.stubs = Array.prototype.slice.call(root.querySelectorAll('[data-ocr-stub]'));
    this.sideL = root.querySelector('[data-ocr-side="l"]');
    this.sideR = root.querySelector('[data-ocr-side="r"]');
  };

  Reveal.prototype.sync = function () {
    var s = this.el.scene;
    if (!s) return;
    if (this.laidOut !== s.clientWidth + 'x' + window.innerHeight) { this.layout(); this.lastP = -1; }
    if (this.reduced) return;
    var p = this.scrollP();
    if (p !== this.lastP) { this.lastP = p; this.paint(p); }
  };

  Reveal.prototype.layout = function () {
    var c = this.conf, s = this.el.scene, st = this.el.stage;
    if (!s || !st) return;
    var w = s.clientWidth, h = window.innerHeight;
    if (w <= 0 || h <= 0) return;
    this.laidOut = w + 'x' + h;
    this.narrow = w < 900;

    // short viewports: trim the fixed chrome instead of shrinking the capsule
    var short = h < 780, tiny = h < 660;
    s.style.padding = (short ? 18 : 34) + 'px clamp(18px,4vw,56px) ' + (short ? 44 : 74) + 'px';
    if (this.el.head) {
      this.el.head.style.fontSize = short ? 'clamp(24px,3.2vw,36px)' : 'clamp(30px,4.4vw,58px)';
      this.el.head.style.margin = (short ? 10 : 14) + 'px 0 0';
    }
    if (this.el.hint) this.el.hint.style.display = tiny ? 'none' : 'flex';

    if (this.el.track) {
      this.el.track.style.height = this.reduced ? 'auto' : (this.narrow ? Math.min(c.vh, 200) : c.vh) + 'vh';
    }
    if (this.reduced && this.el.sticky) {
      this.el.sticky.style.position = 'relative';
      this.el.sticky.style.height = 'auto';
      if (this.el.hint) this.el.hint.style.display = 'none';
    }

    // desktop: cards flank the capsule. narrow: cards move out below the pin.
    var after = this.el.after;
    this.sides.forEach(function (el) { el.style.display = c.cards ? 'flex' : 'none'; });
    var narrow = this.narrow;
    this.stubs.forEach(function (el) { el.style.display = narrow ? 'none' : 'block'; });
    if (this.narrow) {
      if (after && this.sideL && this.sideL.parentNode !== after) { after.appendChild(this.sideL); after.appendChild(this.sideR); }
      if (after) after.style.display = c.cards ? 'grid' : 'none';
      this.sides.forEach(function (el) { el.style.width = 'auto'; });
    } else {
      if (after) after.style.display = 'none';
      if (st && this.sideL && this.sideL.parentNode !== st) { st.insertBefore(this.sideL, this.el.capsule); st.appendChild(this.sideR); }
      this.sides.forEach(function (el) { el.style.width = 'clamp(196px,20vw,286px)'; });
    }

    var avail = st.clientHeight || (h - 220);
    var fitH = (avail - 8) / ART_H;
    var sideW = this.narrow ? 0 : Math.min(286, Math.max(196, w * 0.2)) * 2 + 88;
    var fitW = (w - sideW - 24) / ART_W;
    var k = Math.max(0.22, Math.min(0.68, fitH, fitW));
    var caps = this.el.capsule;
    if (caps) {
      var slackH = ART_H * (1 - k), slackW = ART_W * (1 - k);
      caps.style.transform = 'scale(' + k.toFixed(4) + ')';
      caps.style.transformOrigin = '50% 50%';
      caps.style.marginTop = (-slackH / 2) + 'px';
      caps.style.marginBottom = (-slackH / 2) + 'px';
      caps.style.marginLeft = (-slackW / 2) + 'px';
      caps.style.marginRight = (-slackW / 2) + 'px';
    }
    if (this.reduced) this.paint(0.62);
  };

  Reveal.prototype.scrollP = function () {
    var t = this.el.track;
    if (!t) return 0;
    var usable = t.offsetHeight - window.innerHeight;
    if (usable <= 0) return 0;
    return cl(-t.getBoundingClientRect().top / usable);
  };

  Reveal.prototype.paint = function (p) {
    var e = this.el, c = this.conf;
    var open = out(cl((p - 0.06) / 0.30));
    var shut = 1 - open;
    var burst = out(cl((p - 0.16) / 0.26));
    var settle = cl((p - 0.62) / 0.34);
    var lift = c.lift;

    this.yComp = -shut * CAP_SLIDE * 0.5;
    if (e.cap) e.cap.style.transform = 'translate3d(0,' + (CAP_SLIDE * (1 - open * lift)).toFixed(1) + 'px,0)';
    if (e.cup) e.cup.style.transform = 'translate3d(0,' + (open * 12 * lift).toFixed(1) + 'px,0)';
    if (e.burst) {
      e.burst.style.opacity = String(burst * c.vol * (1 - settle * 0.22));
      e.burst.style.transform = 'scale(' + (0.52 + burst * 0.48 + settle * 0.16).toFixed(3) +
        ') translateY(' + (-burst * 14).toFixed(1) + 'px)';
    }
    if (e.glow) e.glow.style.opacity = String(burst * c.vol * (1 - settle * 0.3));
    if (e.head) e.head.style.opacity = String(1 - cl((p - 0.72) / 0.24) * 0.25);

    var narrow = this.narrow;
    if (this.cards) this.cards.forEach(function (el, i) {
      if (!el) return;
      if (narrow) { el.style.opacity = '1'; el.style.transform = 'none'; return; }
      var a = out(cl((p - (0.30 + i * 0.075)) / 0.14));
      var fromLeft = (i === 0 || i === 2);
      el.style.opacity = String(a);
      el.style.transform = 'translate3d(' + ((fromLeft ? -1 : 1) * (1 - a) * 34).toFixed(1) + 'px,0,0)';
    });
    if (this.stubs) this.stubs.forEach(function (el, i) {
      el.style.opacity = String(out(cl((p - (0.36 + (i % 4) * 0.06)) / 0.16)));
    });
    if (e.hint) e.hint.style.opacity = String(Math.max(0, 1 - Math.max(0, p - 0.68) / 0.16));
  };

  var instances = {};
  // the section is display:none under 861px (hide_on_mobile), so the frame loop,
  // 120 ms poll and scroll listener would run for nothing on phones (phase 23)
  var wideMq = window.matchMedia('(min-width: 861px)');

  function init(scope) {
    if (!wideMq.matches) return;
    var nodes = (scope || document).querySelectorAll('[data-ocr-root]');
    Array.prototype.forEach.call(nodes, function (node) {
      var id = node.getAttribute('data-section-id') || node.id;
      if (instances[id]) instances[id].destroy();
      instances[id] = new Reveal(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // crossing 861px: tear down when the section hides, build when it shows
  var onWide = function () {
    if (wideMq.matches) { init(); return; }
    for (var id in instances) { instances[id].destroy(); delete instances[id]; }
  };
  if (wideMq.addEventListener) wideMq.addEventListener('change', onWide);
  else if (wideMq.addListener) wideMq.addListener(onWide);

  // Shopify theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var node = e.target.querySelector('[data-ocr-root]');
    if (!node) return;
    var id = node.getAttribute('data-section-id');
    if (instances[id]) { instances[id].destroy(); delete instances[id]; }
  });

  window.OptibioCapsuleReveal = { init: init, instances: instances };
})();
